module.exports = __webpack_public_path__ + "static/media/cool-products.b06614ba.png";